import React, { useContext } from "react";
import { useEffect, useState } from "react";
import { ConfigContext } from "../../../../../contexts/ConfigContext";
import Text from "../../Text";

const ErrorException = {
  SCHEMA_VALIDATOR_EXCEPTION: "SchemaValidatorException",
};
export const useNotificationSnackbar = (errorObject) => {
  const { dictionaryValues } = useContext(ConfigContext);

  const [showMoreState, setShowMoreState] = useState(false);
  const [detailsBodyNumberOfLines, setDetailsBodyNumberOfLines] = useState(0);
  const [errorDetails, setErrorDetails] = useState(undefined);

  useEffect(() => {
    if (!errorObject?.status) return;
    setErrorDetails(getErrorDetails(errorObject));
  }, [errorObject]);

  useEffect(() => {
    countDetailsBodyNumberOfLines();
  }, [errorDetails]);

  const getErrorDetails = (errorObject) => {
    const date = errorObject.status !== 403 ? new Date() : undefined;
    if (!errorObject.data?.exception)
      return {
        errorTitle: <Text tId="ACTION_GENERIC_ERROR_TITLE" />,
        errorSubmessage: undefined,
        detailsBody: errorObject.data?.message,
        date,
      };

    const errorException = errorObject.data.exception.split("\\").slice(-1)[0];
    switch (errorException) {
      case ErrorException.SCHEMA_VALIDATOR_EXCEPTION:
        return {
          errorTitle: errorException,
          detailsBody: errorObject.data.schema_errors,
          errorSubmessage: getErrorSubmessage(errorObject),
          date,
        };
      default:
        return {
          errorTitle: errorException,
          detailsBody: errorObject.data?.error,
          errorSubmessage: getErrorSubmessage(errorObject),
          date,
        };
    }
  };

  const getErrorSubmessage = (errorObject) => {
    if (errorObject.status === 429) return "TOO_MANY_REQUESTS";
    if (errorObject && errorObject.data && errorObject.data.exception) {
      try {
        const exceptionName = errorObject.data.exception
          .split("\\")
          .slice(-1)[0];
        const exceptionErrorCode = `EXCEPTION_${exceptionName}`;
        if (dictionaryValues[exceptionErrorCode]) {
          return exceptionErrorCode;
        }
        // eslint-disable-next-line no-empty
      } catch (e) {}
    }
    return undefined;
  };

  const countDetailsBodyNumberOfLines = () => {
    const el = document.getElementById("details-body");
    const divHeight = el?.offsetHeight;
    const computedStyle = el && window.getComputedStyle(el);
    const lineHeight = computedStyle && parseInt(computedStyle?.lineHeight);
    const lines = divHeight && lineHeight && divHeight / lineHeight;
    lines ? setDetailsBodyNumberOfLines(lines) : setDetailsBodyNumberOfLines(0);
  };

  const allowShowMoreButton = detailsBodyNumberOfLines >= 3;

  return {
    allowShowMoreButton,
    showMoreState,
    setShowMoreState,
    errorDetails,
  };
};
